//Built-in libraries
import { useState } from 'react';
//Services
import { useEnsureCurrentWorkspace } from '@/hooks/useEnsureCurrentWorkspace';
//Assets andd Miscellaneous
import { useWorkspaces } from '../../hooks/ReactQueryHooks/useWorkspaceQuery';
import type { IWorkspace } from '../../types/Workspace';
//Third party libraries
//Custom components
import Modal from '../UI/Modal';
import { WorkspaceDropdown } from './WorkspaceDropdown';
import { WorkspaceForm } from './WorkspaceForm';

//Component Begin
export const Workspace = () => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState<IWorkspace>();
  const activeWorkspaces = useEnsureCurrentWorkspace();
  const archivedWorkspaces = useWorkspaces({ params: { archived: 'true' } });
  const isWorkspaceListUnavailable = activeWorkspaces.isError || archivedWorkspaces.isError;
  const allWorkspaces = [...(activeWorkspaces.data || []), ...(archivedWorkspaces.data || [])].filter(
    (workspace, index, workspaces) => workspace.id && workspaces.findIndex((item) => item.id === workspace.id) === index
  );

  const toggleWorkspaceModal = () => {
    setShowModal((prev) => !prev);
  };

  const editWorkspaceHandler = (data: IWorkspace) => {
    setSelectedWorkspace(data);
    toggleWorkspaceModal();
  };

  return (
    <>
      <WorkspaceDropdown handleAddWorkspace={() => toggleWorkspaceModal()} handleEditWorkspace={editWorkspaceHandler} />
      {showModal && (
        <Modal>
          <WorkspaceForm
            workspace={selectedWorkspace}
            workspaces={allWorkspaces}
            isWorkspaceListUnavailable={isWorkspaceListUnavailable}
            handleSubmit={() => {
              toggleWorkspaceModal();
              setSelectedWorkspace(undefined);
            }}
            onCancel={() => {
              toggleWorkspaceModal();
              setSelectedWorkspace(undefined);
            }}
          />
        </Modal>
      )}
    </>
  );
};
